export const FORM_DATA_DROPDWON_SELECT_1 = {
  title: 'Ayúdanos a conocerte',
  title_en: 'Help us get to know you',
  subtitle: 'Ayúdanos a entender cómo inviertes',
  subtitle_en: 'Help us understand how you invest',
  modules: [
    {
      type: 'dropdownSelect',
      id: 3120408441353,
      label: '¿Cuál es tu objetivo principal al invertir en un inmueble?',
      label_en: 'What is your main objective when investing in a property?',
      required: true,
      placeholder: '',
      options: [
        {
          label:
            'Obtener  <strong>ingresos estables y previsibles</strong> desde el primer día',
          label_en:
            'Get <strong>stable and predictable income</strong> from the first day',
          value: 'Obtener ingresos estables y previsibles desde el primer día',
          code: 'CORE',
          selected: false,
        },
        {
          label:
            'Construir <strong>patrimonio sólido</strong> a medio y largo plazo.',
          label_en:
            'Build <strong>solid wealth</strong> over medium and long term.',
          value: 'Construir patrimonio sólido a medio y largo plazo.',
          code: 'CORE PLUS',
          selected: false,
        },
        {
          label:
            '<strong> Incrementar la rentabilidad</strong> mejorando el activo o la gestión.',
          label_en:
            '<strong>Increase profitability</strong> by improving the asset or management.',
          value:
            'Incrementar la rentabilidad mejorando el activo o la gestión.',
          code: 'VALUE ADD',
          selected: false,
        },
        {
          label:
            'Aprovechar <strong>oportunidades de mercado</strong> con alto potencial.',
          label_en:
            'Take advantage of <strong>market opportunities</strong> with high potential.',
          value: 'Aprovechar oportunidades de mercado con alto potencial.',
          code: 'OPPORTUNISTIC',
          selected: false,
        },
      ],
    },
    {
      type: 'dropdownSelect',
      id: 3198574204257,
      label: '¿Qué nivel de riesgo estás dispuesto a asumir?',
      label_en: 'What level of risk are you willing to assume?',
      required: true,
      placeholder: '',
      options: [
        {
          label: 'Bajo: priorizo estabilidad y protección del capital.',
          label_en: 'Low: I prioritize stability and protection of capital.',
          value: 'Bajo: priorizo estabilidad y protección del capital.',
          code: 'CORE',
          selected: false,
        },
        {
          label: 'Medio: acepto cierto riesgo si la rentabilidad mejora.',
          label_en: 'Medium: I accept certain risk if the return improves.',
          value: 'Medio: acepto cierto riesgo si la rentabilidad mejora.',
          code: 'CORE PLUS',
          selected: false,
        },
        {
          label: 'Medio–alto: busco retorno aunque implique más gestión.',
          label_en:
            'Medium-high: I seek return even if it involves more management.',
          value: 'Medio–alto: busco retorno aunque implique más gestión.',
          code: 'VALUE ADD',
          selected: false,
        },
        {
          label: 'Alto: asumo volatilidad si el potencial lo justifica.',
          label_en: 'High: I assume volatility if the potential justifies it.',
          value: 'Alto: asumo volatilidad si el potencial lo justifica.',
          code: 'OPPORTUNISTIC',
          selected: false,
        },
      ],
    },
    {
      type: 'dropdownSelect',
      id: 2801532187770,
      label: '¿Cómo quieres implicarte en la inversión?',
      label_en: 'How do you want to involve yourself in the investment?',
      required: true,
      placeholder: '',
      options: [
        {
          label: 'Mínima implicación, máxima tranquilidad.',
          label_en: 'Minimum involvement, maximum tranquility.',
          value: 'Mínima implicación, máxima tranquilidad.',
          code: 'CORE',
          selected: false,
        },
        {
          label: 'Seguimiento puntual y decisiones estratégicas.',
          label_en: 'Ongoing monitoring and strategic decisions.',
          value: 'Seguimiento puntual y decisiones estratégicas.',
          code: 'CORE PLUS',
          selected: false,
        },
        {
          label: 'Gestión activa para mejorar resultados.',
          label_en: 'Active management to improve results.',
          value: 'Gestión activa para mejorar resultados.',
          code: 'VALUE ADD',
          selected: false,
        },
        {
          label: 'Implicación total si el retorno lo merece.',
          label_en: 'Total involvement if the return is worth it.',
          value: 'Implicación total si el retorno lo merece.',
          code: 'OPPORTUNISTIC',
          selected: false,
        },
      ],
    },
  ],
};

export const FORM_DATA_DROPDWON_SELECT_2 = {
  title: 'Ayúdanos a conocerte',
  title_en: 'Help us get to know you',
  subtitle: '',
  subtitle_en: '',
  modules: [
    {
      type: 'dropdownSelect',
      id: 2720376883395,
      label: '¿Qué te da más tranquilidad al tomar una decisión?',
      label_en: 'What gives you the most peace of mind when making a decision?',
      required: false,
      placeholder: '',
      options: [
        {
          label: 'Flujo de ingresos estable.',
          label_en: 'Stable income flow.',
          value: 'Flujo de ingresos estable.',
          code: 'CORE',
          selected: false,
        },
        {
          label: 'Ubicación consolidada y demanda probada.',
          label_en: 'Consolidated location and proven demand.',
          value: 'Ubicación consolidada y demanda probada.',
          code: 'CORE PLUS',
          selected: false,
        },
        {
          label: 'Potencial de mejora y optimización.',
          label_en: 'Potential for improvement and optimization.',
          value: 'Potencial de mejora y optimización.',
          code: 'VALUE ADD',
          selected: false,
        },
        {
          label: 'Haber detectado una oportunidad clara.',
          label_en: 'Having detected a clear opportunity.',
          value: 'Haber detectado una oportunidad clara.',
          code: 'OPPORTUNISTIC',
          selected: false,
        },
      ],
    },
    {
      type: 'dropdownSelect',
      id: 1931856228159,
      label:
        '¿Qué frase describe mejor cómo quieres que funcione esta inversión para ti?',
      label_en:
        'What phrase describes best how you want this investment to work for you?',
      required: false,
      placeholder: '',
      options: [
        {
          label:
            'Quiero que el inmueble me genere ingresos sin tener que pensar en él.',
          label_en:
            'I want the property to generate income without having to think about it.',
          value:
            'Quiero que el inmueble me genere ingresos sin tener que pensar en él.',
          code: 'CORE',  
          selected: false,
        },
        {
          label: 'Quiero un activo que hoy funcione y que mañana valga más',
          label_en:
            'I want an asset that works today and is worth more tomorrow.',
          value: 'Quiero un activo que hoy funcione y que mañana valga más',
          code: 'CORE PLUS',
          selected: false,
        },
        {
          label:
            'Quiero poder intervenir y mejorar el rendimiento con decisiones activas',
          label_en:
            'I want to intervene and improve performance with active decisions.',
          value:
            'Quiero poder intervenir y mejorar el rendimiento con decisiones activas',
          code: 'VALUE ADD',
          selected: false,
        },
        {
          label: 'Quiero entrar cuando la mayoría no entra y salir con ventaja',
          label_en:
            "I want to enter when most don't and exit with an advantage.",
          value: 'Quiero entrar cuando la mayoría no entra y salir con ventaja',
          code: 'OPPORTUNISTIC',
          selected: false,
        },
      ],
    },
  ],
};

/** Opción de ticket para selects del step Preferencias (sign-in). */
export interface SignInTicketOption {
  name: string;
  value: string;
  isDisabled?: boolean;
}

/** Ticket mínimo (desde): mismos tramos numéricos que el máximo, con etiquetas de suelo. */
export const listsTicketMinPref: SignInTicketOption[] = [
  { name: '0€', value: '0' },
  { name: '100.000€', value: '100000' },
  { name: '200.000€', value: '200000' },
  { name: '300.000€', value: '300000' },
  { name: '500.000€', value: '500000' },
  { name: '1000.000€', value: '1000000' },
  { name: '5000.000€', value: '5000000' },
  { name: 'A partir de 10000.000€', value: '10000000' },
];

/**
 * Ticket máximo (hasta): listado pedido para el presupuesto.
 * El último valor usa un número alto (sin techo), como el ∞ del filtro de edificios.
 */
export const listsTicketMaxPref: SignInTicketOption[] = [
  { name: 'Hasta 100.000€', value: '100000' },
  { name: 'Hasta 200.000 €', value: '200000' },
  { name: 'Hasta 300.000€', value: '300000' },
  { name: 'Hasta 500.000€', value: '500000' },
  { name: 'Hasta 1000.000€', value: '1000000' },
  { name: 'Hasta 5000.000€', value: '5000000' },
  { name: 'Hasta 10000.000€', value: '10000000' },
  { name: 'Hasta ∞', value: '999999999' },
];

export const FORM_DATA_STEP_PREFERENCES = {
  title: '¿Nos cuentas tus preferencias?',
  title_en: 'Tell us your preferences',
  subtitle: 'Deseamos poder ofrecerte el mejor producto para ti',
  subtitle_en: 'We want tobu zonas te interesa invertir?',
  buttonText: 'Finalizar',
  buttonText_en: 'Finish',
  modules: [
    {
      type: 'dropdownSelect',
      id: 1,
      label: '¿En qué zonas te interesa invertir?',
      label_en: 'In which zones are you interested in investing?',
      required: false,
      placeholder: '',
      options: [
        {
          label: '  Madrid ciudad',
          label_en: 'Madrid city',
          value: 'Madrid ciudad',
          selected: false,
          input: false,
        },
        {
          label: 'Área metropolitana de Madrid',
          label_en: 'Madrid metropolitan area',
          value: 'Área metropolitana de Madrid',
          selected: false,
          input: false,
        },
        {
          label: ' Otras capitales de provincia',
          label_en: 'Other provincial capitals',
          value: 'Otras capitales de provincia',
          selected: false,
          input: true,
          inputPlaceholder: 'Ej. Barcelona, Valencia...',
          inputPlaceholder_en: 'E.g. Barcelona, Valencia...',
        },
        {
          label: 'Indiferente, priorizo rentabilidad y datos',
          label_en: 'Indifferent, I prioritize profitability and data',
          value: 'Indiferente, priorizo rentabilidad y datos',
          selected: false,
          input: false,
        },
      ],
    },
  ],
  ticketModules: {
    title:
      'Teniendo en cuenta que podrías obtener una financiación de hasta el 70%, ¿qué presupuesto tienes para invertir?',
    title_en:
      'Considering that you could obtain a financing of up to 70%, what budget do you have for investing?',
    selectGroup: [
      {
        label: 'Ticket mínimo',
        label_en: 'Minimum ticket',
        value: 'Ticket mínimo',
        required: true,
        placeholder: 'Selecciona',
        defaultValue: 'Selecciona',
        options: listsTicketMinPref.map((o) => ({ ...o })),
      },
      {
        label: 'Ticket máximo',
        label_en: 'Maximum ticket',
        value: 'Ticket máximo',
        required: true,
        placeholder: 'Selecciona',
        defaultValue: 'Selecciona',
        options: listsTicketMaxPref.map((o) => ({ ...o })),
      },
    ],
  },
  modulesMultiple: [
    {
      type: 'dropdownSelect',
      id: 2720376883395,
      label:
        'Además de residencial, que otra tipología de activos te interesa?',
      label_en:
        'In addition to residential, which other type of assets are you interested in?',
      required: false,
      placeholder: '',
      options: [
        {
          label: 'Locales u oficinas',
          label_en: 'Offices or shops',
          value: 'Locales u oficinas',
          selected: false,
        },
        {
          label: 'Edificios y grandes activos',
          label_en: 'Buildings and large assets',
          value: 'Edificios y grandes activos',
          selected: false,
        },
        {
          label: 'Residencial obra nueva',
          label_en: 'New residential construction',
          value: 'Residencial obra nueva',
          selected: false,
        },
        {
          label: 'Otros',
          label_en: 'Others',
          value: 'Otros',
          selected: false,
        },
      ],
    },
  ],
  modulesOptions: {
    title: '¿Tienes más inmuebles?',
    title_en: 'Do you have more properties?',
    options: [
      {
        label: 'No',
        label_en: 'No',
        value: 'No',
        selected: false,
      },
      {
        label: '1',
        label_en: '1',
        value: '1',
        selected: false,
      },
      {
        label: '2 a 4',
        label_en: '2 to 4',
        value: '2 a 4',
        selected: false,
      },
      {
        label: 'más de 5',
        label_en: 'more than 5',
        value: 'más de 5',
        selected: false,
      },
    ],
  },
  modulesCheckbox: {
    title:
      'Me interesan inversiones con problemas registrales, okupas o deudas',
    title_en:
      'I am interested in investments with problems of registration, occupation or debt',
    required: false,
  },
};
